import React from 'react';
import { Button } from 'reactstrap';

import { PRIMARY_COLOR } from 'theme';

const PauseButton = ({
  show,
  pauseCommandLoading,
  organizationColor,
  onClick,
}) => {
  const backgroundColor = organizationColor ? organizationColor : PRIMARY_COLOR;

  if (!show) return null;

  return (
    <div style={{ padding: 16 }}>
      <Button
        id="pause-charging"
        className="action-button"
        style={{
          color: 'white',
          backgroundColor,
          borderColor: backgroundColor,
          opacity: pauseCommandLoading ? 0.4 : 1,
        }}
        onClick={onClick}
        disabled={pauseCommandLoading}
      >
        {pauseCommandLoading ? 'Pausing Session' : 'Pause Charging'}
      </Button>
    </div>
  );
};

export default PauseButton;
